var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_4111)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31818 0C2.38602 0 0 2.38602 0 5.31818V12.6818C0 15.614 2.38602 18 5.31818 18H12.6818C15.614 18 18 15.614 18 12.6818V5.31818C18 2.38602 15.614 0 12.6818 0H5.31818ZM5.31818 0.818182H12.6818C15.1717 0.818182 17.1818 2.82826 17.1818 5.31818V12.6818C17.1818 15.1717 15.1717 17.1818 12.6818 17.1818H5.31818C2.82826 17.1818 0.818182 15.1717 0.818182 12.6818V5.31818C0.818182 2.82826 2.82826 0.818182 5.31818 0.818182ZM13.9091 3.27273C13.6921 3.27273 13.484 3.35893 13.3305 3.51237C13.1771 3.66581 13.0909 3.87391 13.0909 4.09091C13.0909 4.3079 13.1771 4.51601 13.3305 4.66945C13.484 4.82289 13.6921 4.90909 13.9091 4.90909C14.1261 4.90909 14.3342 4.82289 14.4876 4.66945C14.6411 4.51601 14.7273 4.3079 14.7273 4.09091C14.7273 3.87391 14.6411 3.66581 14.4876 3.51237C14.3342 3.35893 14.1261 3.27273 13.9091 3.27273ZM9 4.5C6.51956 4.5 4.5 6.51956 4.5 9C4.5 11.4804 6.51956 13.5 9 13.5C11.4804 13.5 13.5 11.4804 13.5 9C13.5 6.51956 11.4804 4.5 9 4.5ZM9 5.31818C11.0383 5.31818 12.6818 6.96174 12.6818 9C12.6818 11.0383 11.0383 12.6818 9 12.6818C6.96174 12.6818 5.31818 11.0383 5.31818 9C5.31818 6.96174 6.96174 5.31818 9 5.31818Z",
    fill: "#00955F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_4111"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.1bd35ac828748760e0fbc7c09946c129.svg";
export { ForwardRef as ReactComponent };